type IconProps = React.SVGProps<SVGSVGElement>;

const AlertCircle: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.38 9.38H10V13.76H10.62M10 17.5C14.14 17.5 17.5 14.14 17.5 10C17.5 5.86 14.14 2.5 10 2.5C5.86 2.5 2.5 5.86 2.5 10C2.5 14.14 5.86 17.5 10 17.5ZM9.84 7.01C10.09 7.01 10.29 6.81 10.29 6.56C10.29 6.31 10.09 6.11 9.84 6.11C9.59 6.11 9.39 6.31 9.39 6.56C9.39 6.81 9.59 7.01 9.84 7.01Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AlertCircle;
